import styled from 'styled-components';
import TextButton from '../../atoms/TextButton/index';
import TextInput from '../../atoms/TextInput';
import InputChip from '../../molecules/InputChip/index';
import Divider from '../../atoms/Divider';
import {OnPrimary,Grey700, Grey300} from '../../Colors';

export default {
	Content : styled.div`
		padding : 1rem;
		overflow : hidden;
	`,
	AnswerNo : styled.div`
		font-size : 0.5rem;
		color : ${OnPrimary};
	`,
	AnswerWrapper : styled.div`
		margin-left : 2rem;
		margin-right : 2rem;
	`,
	AnswerLabel : styled.div`
		text-align: center;
		overflow-x: scroll;
    `,
	AnswerHeader : styled.div`
		display : flex;
		padding : 1rem;
		margin-bottom : 0.5rem;
	`,
	Divider : styled(Divider).attrs({
		color : `${Grey300}`
	})`
	`,
	BlankSize : styled.div`
		text-align : right;
		display : flex;
		justify-content:space-between;
	`,
	BlankSizeCaption : styled.div`
		color : ${Grey700};
		display: flex;
		align-items: center;
	`,
	BlankTextInput : styled(TextInput).attrs(
		{
			type : 'number',
			borderType : 'outlined',
			min : '0',
			max : '99'
		}
	)`
		text-align : center;
		width : 5rem;
		display : block;
	`,
	ErrorMessage : styled.div`
		padding : 1rem;
		color : red;
	`,
	InputChip : styled(InputChip)`
		margin-right : 1rem;
		`,
	OptionsWrapper : styled.div`
		padding-top : 2rem;
		overflow-wrap: break-word;
	`,
	TextButton : styled(TextButton)`
		background-color : transparent;
		&:focus{
			background-color : transparent;
		}
	`,
};